import { createReminderModalStore } from 'stores/modals/model';
import { DatePicker } from 'ui-kit/components/DatePicker';
import { Input } from 'ui-kit/components/inputs/Input';
import { reFormatFromStringToDate } from 'utils/date';
import { GRAY_100 } from 'ui-kit/GlobalStyle/colors';
import { Modal } from 'ui-kit/components/Modal';
import { type FC } from 'types/react';

import { FooterButtonWrap, DateInputWrap, TextInputWrap, PlusIconWrap, SaveButton, Subtitle } from './styles';
import { PlusIconReminder } from './static_assets';

export const CreateReminderModal: FC = () => {
    const { closeModal } = createReminderModalStore;

    return (
        <Modal title="Create reminder" onClose={closeModal} width="530px" visible>
            <TextInputWrap>
                <Input placeholder="Enter reminder title here..." title="Title" />
                <Input placeholder="Enter reminder description here..." title="Description" />
            </TextInputWrap>
            <DateInputWrap>
                <DatePicker
                    defaultDate={reFormatFromStringToDate(new Date().toDateString())}
                    titleColor={GRAY_100}
                    title="Select date"
                />
                <Input placeholder="Enter time" title="Time" />
            </DateInputWrap>
            <Subtitle>Members</Subtitle>
            <PlusIconWrap>
                <PlusIconReminder />
            </PlusIconWrap>
            <FooterButtonWrap>
                <SaveButton onClick={() => closeModal()}>Save</SaveButton>
            </FooterButtonWrap>
        </Modal>
    );
};
